module.exports = __webpack_public_path__ + "img/heart.2544b659.png";